import React from "react";
import { FlatButton } from "material-ui";
import {
  Table,
  TableBody,
  TableFooter,
  TableHeader,
  TableHeaderColumn,
  TableRow,
  TableRowColumn
} from "material-ui/Table";

import * as util from "../../../util";

import InfoTooltip from "../info-tooltip.jsx";
import QuantityEditor from "../quantity-editor.jsx";
import CurrencyField from "../currency-field.jsx";
import LinkLike from "../link-like.jsx";
import BoxOfficeSubitemTableAddItemColumn from "./box-office-subitem-table-add-item-column.jsx";
import BoxOfficeSubitemTablePosPicker from "./box-office-subitem-table-pos-picker.jsx";

class BoxOfficeSubitemTable extends React.Component {
  constructor(props) {
    super(props);

    this.updateQuantity = this.updateQuantity.bind(this);
    this.updatePrice = this.updatePrice.bind(this);
    this.clearSubitems = this.clearSubitems.bind(this);
    this.removeSubitem = this.removeSubitem.bind(this);

    this._makeSubitemContent = this._makeSubitemContent.bind(this);
  }

  updateQuantity(i, quantity) {
    let subitems = this.props.orderData.subitems.map(a => ({ ...a }));
    subitems[i].quantity = quantity;
    this.props.updateCurrentOrder({
      subitems: subitems
    });
  }

  updatePrice(i, price) {
    let subitems = this.props.orderData.subitems.map(a => ({ ...a }));
    subitems[i].price = price;
    this.props.updateCurrentOrder({
      subitems: subitems
    });
  }

  clearSubitems() {
    this.props.updateCurrentOrder({
      subitems: []
    });
  }

  removeSubitem(i) {
    let subitems = this.props.orderData.subitems.map(a => ({ ...a }));
    subitems.splice(i, 1);
    this.props.updateCurrentOrder({
      subitems: subitems
    });
  }

  removeCoupon() {
    this.props.updateCurrentOrder({
      coupon_id: null,
      coupon_code: null,
      checking_coupon: false,
      coupon: null
    });
  }

  _makeSubitemContent(
    {
      name,
      descriptor,
      tooltip,
      subname,
      price,
      originalPrice,
      variablePrice,
      quantity,
      fixedQuantity,
      noDelete,
      tax,
      fee,
      total,
      originalTotal
    },
    i,
    { isPosMode }
  ) {
    const priceEl = variablePrice ? (
      <CurrencyField
        placeholder="$0.00"
        value={price}
        onChange={e => this.updatePrice(i, e.target.value)}
      />
    ) : originalPrice ? (
      <span>
        {util.formatPrice(price)} <s>{util.formatPrice(originalPrice)}</s>
      </span>
    ) : (
      util.formatPrice(price)
    );

    return {
      name: (
        <div>
          {subname || descriptor ? (
            <div>
              <div style={{ lineHeight: 1, marginBottom: "0.3em" }}>{name}</div>
              <div
                style={{
                  fontSize: "0.8em",
                  lineHeight: 1,
                  marginBottom: "0.1em"
                }}
              >
                {descriptor}
              </div>
              <div style={{ fontSize: "0.8em", lineHeight: 1 }}>{subname}</div>
            </div>
          ) : (
            name
          )}{" "}
          {tooltip ? <InfoTooltip text={tooltip} /> : null}
          {isPosMode && !variablePrice ? (
            <div style={{ lineHeight: 1, marginTop: 3 }}>
              @ {priceEl}
              {fee ? (
                <span>
                  {" "}
                  +{" "}
                  {util.formatPrice(
                    fee / (typeof quantity === "number" ? quantity : 1)
                  )}{" "}
                  fee
                </span>
              ) : null}
              {tax ? (
                <span>
                  {" "}
                  +{" "}
                  {util.formatPrice(
                    tax / (typeof quantity === "number" ? quantity : 1)
                  )}{" "}
                  tax
                </span>
              ) : null}
            </div>
          ) : null}
        </div>
      ),
      price: priceEl,
      quantity:
        isPosMode && variablePrice ? (
          priceEl
        ) : variablePrice ? (
          1
        ) : fixedQuantity ? (
          quantity
        ) : (
          <QuantityEditor
            style={{ marginLeft: -16 }}
            quantity={quantity}
            updateQuantity={this.updateQuantity.bind(this, i)}
            min={isPosMode ? 0 : 1}
          />
        ),
      tax: util.formatPrice(tax),
      fee: util.formatPrice(fee),
      total: originalTotal ? (
        <span>
          {util.formatPrice(total)} <s>{util.formatPrice(originalTotal)}</s>
        </span>
      ) : (
        util.formatPrice(total)
      ),
      noDelete: noDelete
    };
  }

  getStyles() {
    return {
      delete: {
        width: 5,
        textAlign: "center",
        fontSize: "1.3em",
        overflow: "visible"
      },
      wrapCell: {
        whiteSpace: "normal",
        overflow: "visible"
      }
    };
  }

  render() {
    let { orderData, processedData, displayMode } = this.props;

    const isPosMode = displayMode === "pos";

    if (!orderData.event_bucket) {
      return null;
    }

    const styles = this.getStyles();

    let subitemData = processedData.subitems,
      subitemContent = subitemData
        .filter(i => !i.hidden)
        .map((item, i) => this._makeSubitemContent(item, i, { isPosMode }));

    let { originalTotal, total } = processedData;

    const hasTax = processedData.subitems.some(subitem => subitem.tax);
    const hasFee = processedData.subitems.some(subitem => subitem.fee);

    let couponRow;
    if (orderData.checking_coupon) {
      couponRow = (
        <TableRow>
          {isPosMode ? null : <TableRowColumn style={{ width: 5 }} />}
          <TableRowColumn colSpan={isPosMode ? "2" : hasFee ? "4" : "3"}>
            <i>Applying coupon...</i>
          </TableRowColumn>
          <TableRowColumn>
            <strong>
              {originalTotal && originalTotal !== total ? (
                <span>
                  {util.formatPrice(total)}{" "}
                  <s>{util.formatPrice(originalTotal)}</s>
                </span>
              ) : null}
            </strong>
          </TableRowColumn>
        </TableRow>
      );
    } else if (orderData.coupon) {
      couponRow = (
        <TableRow>
          {isPosMode ? null : (
            <TableRowColumn style={styles.delete}>
              <span
                style={{ cursor: "pointer" }}
                onClick={() => this.removeCoupon()}
              >
                ×
              </span>
            </TableRowColumn>
          )}
          <TableRowColumn
            style={styles.wrapCell}
            colSpan={isPosMode ? "2" : hasFee ? "4" : "3"}
          >
            {orderData.coupon.is_applicable ? (
              <span>
                Discount applied: <strong>{orderData.coupon.name}</strong> (
                <LinkLike onTouchTap={() => this.removeCoupon()}>
                  Remove
                </LinkLike>
                )
              </span>
            ) : (
              <span>
                <strong>
                  {orderData.coupon.error || orderData.subitems.length > 0
                    ? "Discount not applicable"
                    : "Discount ready to be applied"}
                  :
                </strong>{" "}
                {orderData.coupon.error ||
                  (orderData.subitems.length === 0
                    ? "No items in cart, yet. Why not add some?"
                    : "Unknown error")}{" "}
                (
                <LinkLike onTouchTap={() => this.removeCoupon()}>
                  Remove
                </LinkLike>
                )
              </span>
            )}
          </TableRowColumn>
          <TableRowColumn>
            <strong>
              {originalTotal && originalTotal !== total ? (
                <span>
                  {util.formatPrice(total)}{" "}
                  <s>{util.formatPrice(originalTotal)}</s>
                </span>
              ) : null}
            </strong>
          </TableRowColumn>
        </TableRow>
      );
    }

    let passRow;
    if (orderData.checking_pass) {
      passRow = (
        <TableRow>
          {isPosMode ? null : <TableRowColumn style={{ width: 5 }} />}
          <TableRowColumn colSpan={isPosMode ? "2" : "3"}>
            <i>Applying pass...</i>
          </TableRowColumn>
          <TableRowColumn>
            <strong>
              {originalTotal && originalTotal !== total ? (
                <span>
                  {util.formatPrice(total)}{" "}
                  <s>{util.formatPrice(originalTotal)}</s>
                </span>
              ) : null}
            </strong>
          </TableRowColumn>
        </TableRow>
      );
    } else if (orderData.pass) {
      passRow = (
        <TableRow>
          {isPosMode ? null : <TableRowColumn style={{ width: 5 }} />}
          <TableRowColumn
            style={styles.wrapCell}
            colSpan={isPosMode ? "2" : "3"}
          >
            <div>
              <div>
                <span>
                  Pass applied: <strong>{orderData.pass.name}</strong>
                </span>
              </div>
              <div>
                {[
                  ...new Set(
                    orderData.pass_data.subitems.reduce(
                      (a, i, index) =>
                        a.concat(
                          i && i.errors
                            ? i.errors.map(e =>
                                subitemData[index]
                                  ? e.replace(
                                      /this event/,
                                      subitemData[index].name
                                    )
                                  : e
                              )
                            : []
                        ),
                      []
                    )
                  )
                ].join("; ")}
              </div>
            </div>
          </TableRowColumn>
          <TableRowColumn>
            <strong>
              {originalTotal && originalTotal !== total ? (
                <span>
                  {util.formatPrice(total)}{" "}
                  <s>{util.formatPrice(originalTotal)}</s>
                </span>
              ) : null}
            </strong>
          </TableRowColumn>
        </TableRow>
      );
    }

    const table = (
      <Table
        selectable={false}
        wrapperStyle={{ overflow: "visible" }}
        style={{ overflow: "visible" }}
        bodyStyle={{ overflow: "visible" }}
      >
        <TableHeader
          displaySelectAll={false}
          adjustForCheckbox={false}
          style={{ backgroundColor: "#0288d1" }}
        >
          <TableRow style={{ height: 24 }} displayRowCheckbox={false}>
            {!isPosMode ? (
              <TableHeaderColumn
                style={Object.assign({}, styles.delete, { height: 24 })}
              >
                <span
                  style={{ cursor: "pointer" }}
                  onClick={() => this.clearSubitems()}
                >
                  ×
                </span>
              </TableHeaderColumn>
            ) : null}
            <TableHeaderColumn style={{ height: 24 }}>Item</TableHeaderColumn>
            <TableHeaderColumn style={{ height: 24 }}>
              Quantity
            </TableHeaderColumn>
            {!isPosMode ? (
              <TableHeaderColumn style={{ height: 24 }}>
                Price/ea.
              </TableHeaderColumn>
            ) : null}
            {hasTax && !isPosMode ? (
              <TableHeaderColumn style={{ height: 24 }}>Tax</TableHeaderColumn>
            ) : null}
            {hasFee && !isPosMode ? (
              <TableHeaderColumn style={{ height: 24 }}>Fee</TableHeaderColumn>
            ) : null}
            <TableHeaderColumn style={{ height: 24 }}>Total</TableHeaderColumn>
          </TableRow>
        </TableHeader>
        <TableBody displayRowCheckbox={false} style={{ overflow: "visible" }}>
          {subitemContent.map((content, i) => {
            return (
              <TableRow>
                {!isPosMode ? (
                  <TableRowColumn style={styles.delete}>
                    {!content.noDelete && (
                      <span
                        style={{ cursor: "pointer" }}
                        onClick={() => this.removeSubitem(i)}
                      >
                        ×
                      </span>
                    )}
                  </TableRowColumn>
                ) : null}
                <TableRowColumn style={styles.wrapCell}>
                  {content.name}
                </TableRowColumn>
                <TableRowColumn>{content.quantity}</TableRowColumn>
                {!isPosMode ? (
                  <TableRowColumn style={styles.wrapCell}>
                    {content.price}
                  </TableRowColumn>
                ) : null}
                {hasTax && !isPosMode ? (
                  <TableRowColumn style={styles.wrapCell}>
                    {content.tax}
                  </TableRowColumn>
                ) : null}
                {hasFee && !isPosMode ? (
                  <TableRowColumn style={styles.wrapCell}>
                    {content.fee}
                  </TableRowColumn>
                ) : null}
                <TableRowColumn style={styles.wrapCell}>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center"
                    }}
                  >
                    <div>{content.total}</div>

                    {isPosMode && !content.noDelete ? (
                      <div
                        style={{
                          cursor: "pointer",
                          fontSize: 30
                        }}
                        onClick={() => this.removeSubitem(i)}
                      >
                        ×
                      </div>
                    ) : null}
                  </div>
                </TableRowColumn>
              </TableRow>
            );
          })}

          {subitemContent.length === 0 ? (
            // Filler row to keep the widths correct (to account for 5px wide "x" column)
            // This ensures $0.00 total is in line with "Total header"
            <TableRow style={{ border: 0, height: 0, padding: 0 }}>
              {!isPosMode ? (
                <TableRowColumn
                  style={{
                    width: 5,
                    height: 0,
                    paddingTop: 0,
                    paddingBottom: 0
                  }}
                />
              ) : null}
              <TableRowColumn
                style={{ height: 0, paddingTop: 0, paddingBottom: 0 }}
                colSpan={isPosMode ? "3" : "4"}
              />
            </TableRow>
          ) : null}

          {subitemContent.length === 0 && isPosMode ? (
            // In POS mode, show a placeholder since it's so tall
            <TableRow>
              <TableRowColumn
                style={{ textAlign: "center", fontStyle: "italic" }}
                colSpan="3"
              >
                Nothing in the cart yet &ndash; why not add something?
              </TableRowColumn>
            </TableRow>
          ) : null}

          {passRow}
          {couponRow}

          <TableRow style={{ overflow: "visible" }}>
            {isPosMode ? (
              <TableRowColumn colSpan="1">
                {subitemContent.length ? (
                  <FlatButton
                    label="Reset"
                    secondary
                    labelStyle={{ padding: "0px 10px" }}
                    style={{ marginLeft: -10, marginRight: -10 }}
                    onClick={() => this.clearSubitems()}
                  />
                ) : null}
              </TableRowColumn>
            ) : (
              <BoxOfficeSubitemTableAddItemColumn
                colSpan={hasTax || hasFee ? "5" : "4"}
                orderData={orderData}
                updateCurrentOrder={this.props.updateCurrentOrder}
              />
            )}
            <TableRowColumn
              style={{
                fontWeight: "bold",
                fontSize: "2em",
                overflow: "visible",
                textAlign: isPosMode ? "right" : undefined
              }}
              colSpan={isPosMode ? "2" : undefined}
            >
              {processedData.groupSalesSize ? (
                <div
                  style={{
                    fontSize: "0.5em",
                    fontWeight: "normal",
                    marginBottom: "0.25em",
                    marginTop: "-0.2em"
                  }}
                >
                  {processedData.groupSalesSize} x{" "}
                  {util.formatPrice(
                    processedData.total / processedData.groupSalesSize
                  )}{" "}
                  =
                </div>
              ) : null}
              {util.formatPrice(total)}
            </TableRowColumn>
          </TableRow>
        </TableBody>
      </Table>
    );

    if (!isPosMode) {
      return table;
    }

    return (
      <div style={{ display: "flex", alignItems: "stretch", marginTop: 20 }}>
        {/*<div>
          <BoxOfficeSubitemTableAddItemColumn
            colSpan={hasTax ? "5" : "4"}
            orderData={orderData}
            updateCurrentOrder={this.props.updateCurrentOrder}
          />
        </div>*/}
        <div
          style={{
            display: "flex",
            width: "70%",
            maxWidth: "70%"
          }}
        >
          <BoxOfficeSubitemTablePosPicker
            orderData={orderData}
            updateCurrentOrder={this.props.updateCurrentOrder}
            posConfig={this.props.posConfig}
            updatePosConfig={this.props.updatePosConfig}
          />
        </div>
        <div
          style={{
            flex: 1,
            minWidth: 400
          }}
        >
          <div
            className="sticky top-24"
            style={{
              border: "1px solid #0288d1",
              borderRadius: 5,
              overflow: "hidden"
            }}
          >
            {table}
          </div>
        </div>
      </div>
    );
  }
}

export default BoxOfficeSubitemTable;



// WEBPACK FOOTER //
// ./src/app/components/partials/box-office/box-office-subitem-table.jsx